var render = function render(){var _vm=this,_c=_vm._self._c;return _c('proceed-list',{attrs:{"scene":"approve"}})
}
var staticRenderFns = []

export { render, staticRenderFns }